export const BeAnInvestor = '/user/investor/create'
export const VerifyInvestor = '/user/investor/verify-otp'